var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 853,
    viewBox: "0 0 1024 853",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1022,
    height: 851,
    rx: 8,
    fill: "#FBFAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1022,
    height: 851,
    rx: 8,
    stroke: "#C6C9CA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 403V247C360 238.716 366.716 232 375 232H564L671 339V403",
    stroke: "#D8D8F5",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M562 234V342H670",
    stroke: "#D8D8F5",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M358.5 587V472H406.5C429.696 472 447.5 489.804 447.5 513C447.5 536.196 429.696 554 406.5 554H387.5V587H358.5ZM387.5 529H404.5C413.889 529 419.5 522.948 419.5 513C419.5 503.052 413.889 497 404.5 497H387.5V529ZM469.5 587V472H517.5C552.018 472 576.5 495.386 576.5 529.5C576.5 563.614 552.018 587 517.5 587H469.5ZM498.5 562H515.5C533.391 562 547.5 550.015 547.5 529.5C547.5 508.985 533.391 497 515.5 497H498.5V562ZM600.5 587V472H681.5V497H629.5V519H674.5V544H629.5V587H600.5Z",
    fill: "#D8D8F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfPlaceholder);
export default __webpack_public_path__ + "static/media/pdf-placeholder.1858194b28bc5b7881b4e6656b38bd43.svg";
export { ForwardRef as ReactComponent };